<script setup>
// import avatar1 from '@images/avatars/avatar-1.png'

const store = useUserStore()

const logout = async () => {
  console.log('logout')
  try {
    await useApi('/accounts/logout', {}, {}, 2)
    store.logout()
    store.$reset()
    await navigateTo('/')
  }catch (e) {
    console.log(e)
  }
}

const goto = route => {
  navigateTo(route)
}

const isAdmin = store.profile?.acl === 'Company' && store.profile?.role === 'Admin'
</script>

<template>
  <VBadge
    dot
    location="bottom right"
    offset-x="3"
    offset-y="3"
    bordered
    color="success"
  >
    <VAvatar
      class="cursor-pointer"
      color="primary"
      variant="tonal"
    >
      <VIcon
        icon="tabler-user-scan"
        size="22"
      />

      <!-- SECTION Menu -->
      <VMenu
        activator="parent"
        width="230"
        location="bottom end"
        offset="14px"
      >
        <VList>
          <!-- 👉 User Avatar & Name -->
          <VListItem>
            <template #prepend>
              <VListItemAction start>
                <VBadge
                  dot
                  location="bottom right"
                  offset-x="3"
                  offset-y="3"
                  color="success"
                >
                  <VAvatar
                    color="primary"
                    variant="tonal"
                  >
                    <VIcon
                      icon="tabler-user-scan"
                      size="22"
                    />
                  </VAvatar>
                </VBadge>
              </VListItemAction>
            </template>

            <VListItemTitle class="font-weight-semibold">
              {{ store.profile.first_name }} {{ store.profile.last_name }}
            </VListItemTitle>
            <VListItemSubtitle>Role: {{ store.profile.role }}</VListItemSubtitle>
          </VListItem>

          <VDivider class="my-2" />

          <!-- 👉 Profile -->
          <VListItem
            link
            @click="goto('/business/profile')"
          >
            <template #prepend>
              <VIcon
                class="me-2"
                icon="tabler-user"
                size="22"
              />
            </template>

            <VListItemTitle>
              Company Profile
            </VListItemTitle>
          </VListItem>

          <!-- 👉 Settings -->
          <VListItem
            link
            @click="goto('/business/settings')"
          >
            <template #prepend>
              <VIcon
                class="me-2"
                icon="tabler-settings"
                size="22"
              />
            </template>

            <VListItemTitle>
              Settings
            </VListItemTitle>
          </VListItem>

       
          <!-- 👉 FAQ -->
          <VListItem
            link
            @click="goto('/business/faq')"
          >
            <template #prepend>
              <VIcon
                class="me-2"
                icon="tabler-help"
                size="22"
              />
            </template>

            <VListItemTitle>FAQ</VListItemTitle>
          </VListItem>

          <!-- Divider -->
          <VDivider class="my-2" />

          <!-- 👉 Logout -->
          <VListItem
            link
            @click="logout"
          >
            <template #prepend>
              <VIcon
                class="me-2"
                icon="tabler-logout"
                size="22"
              />
            </template>

            <VListItemTitle>
              Logout
            </VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
      <!-- !SECTION -->
    </VAvatar>
  </VBadge>
</template>
